import Vue from 'vue'
import Vuex from 'vuex'

import guide from './modules/guide'
import modal from './modules/modal'
import general from './modules/general'

Vue.use(Vuex)

const store = new Vuex.Store({
  modules: {
    general,
    guide,
    modal
  }
})

store.subscribe(({type, payload}, state) => {
  switch (type) {
    case 'UPDATE_CURRENT_EPG':
      store.commit('UPDATE_NOW_TIME')
      store.commit('UPDATE_CHANNEL_FOR_EPG')
      store.commit('UPDATE_EPG_FOR_LIST')
      break
  }
})

export { store }



// WEBPACK FOOTER //
// ./src/store/store.js